import React, { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext();

const LIGHT_VARS = {
  "--bg":               "#f7f7f5",
  "--bg-card":          "#ffffff",
  "--bg-subtle":        "#f2f2ef",
  "--text":             "#1a1a18",
  "--text-2":           "#6b6b66",
  "--text-3":           "#9a9a93",
  "--border":           "#e6e6e2",
  "--border-2":         "#d8d8d3",
  "--primary-bg":       "#FBF0E8",
  "--success-bg":       "#f0fdf4",
  "--success-text":     "#16a34a",
  "--success-border":   "#bbf7d0",
  "--error-bg":         "#fef2f2",
  "--error-text":       "#dc2626",
  "--error-border":     "#fecaca",
  "--warning-bg":       "#fffbeb",
  "--warning-text":     "#92400e",
  "--warning-border":   "#fde68a",
  "--info-bg":          "#eff6ff",
  "--info-text":        "#2563eb",
  "--info-border":      "#bfdbfe",
};

const DARK_VARS = {
  "--bg":               "#18181a",
  "--bg-card":          "#242428",
  "--bg-subtle":        "#2e2e32",
  "--text":             "#f2f2ef",
  "--text-2":           "#a0a09a",
  "--text-3":           "#6b6b66",
  "--border":           "#3a3a3f",
  "--border-2":         "#4a4a50",
  "--primary-bg":       "rgba(212,98,13,0.15)",
  "--success-bg":       "rgba(22,163,74,0.13)",
  "--success-text":     "#86efac",
  "--success-border":   "rgba(22,163,74,0.28)",
  "--error-bg":         "rgba(220,38,38,0.13)",
  "--error-text":       "#fca5a5",
  "--error-border":     "rgba(220,38,38,0.28)",
  "--warning-bg":       "rgba(245,158,11,0.13)",
  "--warning-text":     "#fcd34d",
  "--warning-border":   "rgba(245,158,11,0.28)",
  "--info-bg":          "rgba(37,99,235,0.13)",
  "--info-text":        "#93c5fd",
  "--info-border":      "rgba(37,99,235,0.28)",
};

function applyVars(vars) {
  const root = document.documentElement;
  Object.entries(vars).forEach(([k, v]) => root.style.setProperty(k, v));
}

export function ThemeProvider({ children }) {
  const [isDark, setIsDark] = useState(
    () => localStorage.getItem("theme") === "dark",
  );

  useEffect(() => {
    applyVars(isDark ? DARK_VARS : LIGHT_VARS);
    document.documentElement.setAttribute("data-theme", isDark ? "dark" : "light");
    localStorage.setItem("theme", isDark ? "dark" : "light");
  }, [isDark]);

  // Apply immediately on mount (before paint)
  useEffect(() => {
    applyVars(isDark ? DARK_VARS : LIGHT_VARS);
    document.documentElement.setAttribute("data-theme", isDark ? "dark" : "light");
  }, []);

  return (
    <ThemeContext.Provider value={{ isDark, toggleTheme: () => setIsDark((d) => !d) }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
